<template>  
  <v-container fluid grid-list-lg class="ma-0 pa-0">
    <v-card flat>
      <v-card-text>
        <v-layout row>
          <v-flex xs6 md3 lg2 v-if="!disabled.addr_idkab">
            <v-autocomplete outlined dense hide-no-data hide-details
              v-model="fm.addr_idpro"
              label="Provinsi"
              :items="provinsi"
              item-text="name"
              item-value="id"
              :loading="provinsiLoading"
              :disabled="disabled.addr_idpro"
              clearable
              autocomplete="off"
            />
          </v-flex>
          <v-flex xs6 md3 lg2>  
            <v-autocomplete outlined dense hide-no-data hide-details
              v-model="fm.addr_idkab"
              label="Kabupaten/Kota"
              :items="kabupaten"
              item-text="name"
              item-value="id"
              :loading="kabupatenLoading"
              :disabled="disabled.addr_idkab"
              clearable autocomplete="off"
            />
          </v-flex>
          <v-flex xs6 md3 lg2>  
            <v-autocomplete outlined dense hide-no-data hide-details
              v-model="fm.addr_idkec"
              label="Kecamatan"
              :items="kecamatan"
              item-text="name"
              item-value="id"
              :loading="kecamatanLoading"
              :disabled="disabled.addr_idkec"
              clearable autocomplete="off"
            />
          </v-flex>
          <v-flex xs6 md3 lg2>  
            <v-autocomplete outlined dense hide-no-data hide-details
              v-model="fm.addr_idkel"
              label="Kelurahan"
              :items="kelurahan"
              item-text="name"
              item-value="id"
              :loading="kelurahanLoading"
              :disabled="disabled.addr_idkel"
              clearable autocomplete="off"
            />
          </v-flex>                   
        </v-layout>        
      </v-card-text>
      <v-divider />
      <v-card-text>
        <v-layout row>
          <v-flex xs12 md4>
            <v-card>
              <v-card-text class="pa-0" id="exportdpt" style="position:relative; overflow:auto">
                <v-btn color="success" dark @click="export2excel('dpt')" small style="position:absolute; left:2px; top:2px">
                    <v-icon left>select_all</v-icon>.xls
                  </v-btn>
                  <table class="tb-normal" style="width:100%">
                    <thead class="white--text blue">
                      <tr>
                        <th>No.</th>
                        <template>
                          <th v-if="fm.addr_idkel">TPS</th>
                          <th v-else-if="fm.addr_idkec">Kelurahan</th>
                          <th v-else-if="fm.addr_idkab">Kecamatan</th>
                          <th v-else-if="fm.addr_idpro">Kebupaten/Kota</th>                                                
                        </template>                      
                        <th class="text-right">Jumlah TPS</th>                        
                        <th class="text-right">Jumlah DPT</th>
                        <th class="text-right">Sample</th>
                        <th class="text-right">Sebaran</th>
                      </tr>                      
                    </thead>
                    <template v-if="fm.addr_idkel">
                      <tbody>
                        <tr v-for="(item, i) in tps" :key="'kec'+i">
                          <td valign="top">{{i+1}}</td>
                          <td valign="top">{{item.name}}</td>
                          <td v-if="i==0" class="text-right" valign="top" :rowspan="tps.length">{{tps.length}}</td>                          
                          <td class="text-right" valign="top">{{item.dpt}}</td>
                          <td v-if="i==0" class="text-right" valign="top" :rowspan="tps.length">{{kelurahan.find(x=>x.id==fm.addr_idkel).lembar}}</td>
                          <td class="text-right" valign="top">{{item.lembarDone}}</td>
                        </tr>
                      </tbody>
                      <tfoot v-if="tps.length == 0">
                        <tr><th colspan="5">No Data Result</th></tr>                      
                      </tfoot>
                      <tfoot v-else>
                        <tr>
                          <th colspan="2" class="text-left">Total</th>
                          <td class="text-right"><strong>{{tps.length}}</strong></td>                            
                          <td class="text-right"><strong>{{totalDpt(tps).dpt}}</strong></td>                                                                                                    
                          <td class="text-right"><strong>{{kelurahan.find(x=>x.id==fm.addr_idkel).lembar}}</strong></td>                                                                                                    
                          <td class="text-right"><strong>{{totalDpt(tps).lembarDone}}</strong></td>                                                                                                    
                        </tr>  
                      </tfoot>
                    </template> 
                    <template v-else>
                      <tbody>
                        <tr v-for="(item, i) in getNodesActive()" :key="'kec'+i">
                          <td valign="top">{{i+1}}</td>
                          <td valign="top">{{item.name}}</td>
                          <td valign="top" class="text-right">{{item.jumlahTps}}</td>
                          <td valign="top" class="text-right">{{item.dpt}}</td>
                          <td valign="top" class="text-right">{{item.lembar}}</td>
                          <td valign="top" class="text-right">{{item.lembarDone}}</td>
                        </tr>
                      </tbody>
                      <tfoot v-if="getNodesActive().length == 0">
                        <tr><th colspan="5">No Data Result</th></tr>                      
                      </tfoot>
                      <tfoot v-else>
                        <tr>
                          <th colspan="2" class="text-left">Total</th>
                          <td class="text-right"><strong>{{totalDpt(getNodesActive()).jumlahTps}}</strong></td>                          
                          <td class="text-right"><strong>{{totalDpt(getNodesActive()).dpt}}</strong></td>
                          <td class="text-right"><strong>{{totalDpt(getNodesActive()).lembar}}</strong></td>
                          <td class="text-right"><strong>{{totalDpt(getNodesActive()).lembarDone}}</strong></td>
                        </tr>  
                      </tfoot>
                    </template>                                                                                                    
                  </table>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 md3>
            <v-card>              
              <echart v-if="!loading" :option="option1" :height="height1+'px'" />
              <template v-else>
                <v-skeleton-loader                
                  style="width:100%"
                  type="card, article"
                ></v-skeleton-loader>
              </template>
            </v-card>               
          </v-flex>  
          <v-flex xs12 md5>
            <v-layout row v-if="fm.addr_idkec">
              <v-flex xs4 md2 v-for="(item, i) in kelurahan" :key="i">
                <v-card>
                  <v-card-text class="pa-0 pt-2 text-center">                    
                    <v-progress-circular
                      :rotate="360"
                      :size="70"
                      :width="10"
                      :value="parseInt(parseInt(item.lembarDone)/parseInt(item.lembar)*100)"
                      :color="color"
                    >
                      {{ item.lembarDone }}/{{item.lembar}}
                    </v-progress-circular>
                    <p class="mb-0 caption"><small>{{item.name}}</small></p>
                  </v-card-text>                  
                </v-card>
              </v-flex>
            </v-layout>
            <v-layout row v-else-if="fm.addr_idkab">
              <v-flex xs4 md2 v-for="(item, i) in kecamatan" :key="i">
                <v-card>
                  <v-card-text class="pa-0 pt-2 text-center">                    
                    <v-progress-circular
                      :rotate="360"
                      :size="70"
                      :width="10"
                      :value="parseInt(parseInt(item.lembarDone)/parseInt(item.lembar)*100)"
                      :color="color"
                    >
                      {{ item.lembarDone }}/{{item.lembar}}
                    </v-progress-circular>
                    <p class="mb-0 caption"><small>{{item.name}}</small></p>
                  </v-card-text>                  
                </v-card>
              </v-flex>
            </v-layout>
            <v-layout row v-else-if="fm.addr_idpro">
              <v-flex xs4 md2 v-for="(item, i) in kabupaten" :key="i">
                <v-card>
                  <v-card-text class="pa-0 pt-2 text-center">                    
                    <v-progress-circular
                      :rotate="360"
                      :size="70"
                      :width="10"
                      :value="parseInt(parseInt(item.lembarDone)/parseInt(item.lembar)*100)"
                      :color="color"
                    >
                      {{ item.lembarDone }}/{{item.lembar}}
                    </v-progress-circular>
                    <p class="mb-0 caption"><small>{{item.name}}</small></p>
                  </v-card-text>                  
                </v-card>
              </v-flex>
            </v-layout>
            <v-layout row v-else-if="fm.addr_idneg">
              <v-flex xs4 md2 v-for="(item, i) in provinsi" :key="i">
                <v-card>
                  <v-card-text class="pa-0 pt-2 text-center">                    
                    <v-progress-circular
                      :rotate="360"
                      :size="70"
                      :width="10"
                      :value="parseInt(parseInt(item.lembarDone)/parseInt(item.lembar)*100)"
                      :color="color"
                    >
                      {{ item.lembarDone }}/{{item.lembar}}
                    </v-progress-circular>
                    <p class="mb-0 caption"><small>{{item.name}}</small></p>
                  </v-card-text>                  
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>                  
        </v-layout>
      </v-card-text>
      <v-divider />
      <v-card-text>
        <v-layout row>
          <v-flex xs12 md6>
            <v-autocomplete outlined dense hide-no-data hide-details
              v-model="fm2.nomors"
              label="Disilangkan dengan Pertanyaan"
              :items="pertanyaans"
              item-text="name"        
              item-value="id"      
              multiple
              :loading="pertanyaanLoading"
              autocomplete="off"
            />
          </v-flex>          
          <v-flex xs12 md3 >
            <v-autocomplete outlined dense hide-no-data hide-details
              v-model="fm2.dapil"
              label="Pilih Dapil"
              :items="dapil"
              item-text="name"
              item-value="id"
              :loading="dapilLoading"
              clearable
              autocomplete="off"              
            />
          </v-flex>
          <v-flex xs12 md3>

            <v-autocomplete outlined dense hide-no-data hide-details
              v-model="fm2.areas"
              label="Areas"
              :items="area.items"
              item-text="name"
              item-value="id"
              :loading="area.loading"              
              clearable autocomplete="off"
              multiple
            />
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider />
      <v-card-text>
        <v-layout row>
          <v-flex xs12 v-for="(item, i) in charts" :key="i">
            <v-card>                  
              <template v-if="!item.loading">
                <v-card-text class="v-data-table__wrapper pa-0 mb-3" :id="'export'+i" style="position:relative; overflow:auto">
                  <v-btn color="success" dark @click="export2excel(i)" small style="position:absolute; right:2px; top:2px">
                    <v-icon left>select_all</v-icon>.xls
                  </v-btn>
                  <table class="tb-normal" style="width:100%">
                    <thead class="white--text" :style="'background:'+(item.color?item.color:'#000')">
                      <tr>
                        <th rowspan="2">No.</th>
                        <template>
                          <th rowspan="2" v-if="fm.addr_idkel">TPS</th>
                          <th rowspan="2" v-else-if="fm.addr_idkec">Kelurahan</th>
                          <th rowspan="2" v-else-if="fm.addr_idkab">Kecamatan</th>
                          <th rowspan="2" v-else-if="fm.addr_idpro">Kebupaten/Kota</th>                                                
                        </template>                      
                        <!--<td style="display:none" rowspan="2" class="text-right">Sample</td>-->
                        <td :colspan="item.columns.length*1">{{item.no+'. '+item.question}}</td>
                      </tr>
                      <tr>
                        <th v-for="(column, i) in item.columns" colspan="1" :key="i">{{column.text}}</th>
                      </tr>                    
                    </thead>
                    <tbody>
                      <tr v-for="(data, i) in item.data" :key="i">
                        <td>{{i+1}}</td>
                        <td>{{data.area_name}}</td>       
                        <!--<td style="display:none" class="text-right">{{data.people}}</td>-->
                        <template v-for="(child, j) in data.childs">
                          <td :key="j" class="text-right">{{child.persen}}%</td>
                          <!--<td  style="display:none" :key="'persen'+j" class="text-right">{{child.people}}</td>-->
                                                                                                      
                        </template>                      
                      </tr>
                    </tbody>                    
                    <tfoot v-if="item.data.length <= 0">
                      <tr><th colspan="3">No Data Result</th></tr>
                    </tfoot>
                    <tfoot v-else>
                      <tr v-if="item.data[0]">
                        <th colspan="2">Total</th>
                        <!--<th style="display:none" class="text-right"><strong>{{item.subtotal}}</strong></th>-->
                        <template v-for="(child, j) in item.data[0].childs">                           
                          <td :key="j" class="text-right"><strong>{{item.total_persen[j]}}%</strong></td>
                          <!--<td  style="display:none" :key="'persen'+j" class="text-right"><strong>{{item.total_people[j]}}</strong></td>--> 
                        </template>
                      </tr>  
                    </tfoot>
                  </table>
                </v-card-text>
                <!--<echart :option="item.chartOption" :height="item.height? item.height+'px':'390px'" />-->
              </template> 
              <template v-else>
                <v-skeleton-loader                
                  style="width:100%"
                  type="card, article"
                ></v-skeleton-loader>
              </template>
            </v-card>               
          </v-flex>          
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import Table2Excel  from 'table2excel.js';  
import Echart from '@/app/components/other/echart';
import { debounce } from 'lodash'
import Model from '@/app/models/Report'
const  model = new Model()

export default {
  components:{Echart},
  props:{
    jilid : {type:Object}
  },
  data () {
    return {
      load:0,
      fm:{ tps_id:null, addr_idneg:null, addr_idpro:null, addr_idkab: null, addr_idkec:null, addr_idkel:null},    
      disabled : {addr_idpro : false, addr_idkab: false, addr_idkec: false, addr_idkel:false},
      negara:[], provinsi  : [], kabupaten : [], kecamatan : [], kelurahan : [], tps:[],
      negaraLoading:false, provinsiLoading  : false, kabupatenLoading : false, kecamatanLoading : false, kelurahanLoading : false, tpsLoading:false,
      loading : false, firstime:true,
      height1 : 390, height2 : 390, color:null,
      option1 :  {
        title: {
            text: 'Sebaran (%)',
            subtext: 'Responden'
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            },
            formatter: "{b} : {c}%"    
        },
        legend: {
            data: ['responden']
        },
        toolbox: {
            show : true,
            x: 'right',
            feature : {
                mark : {show: true},
                //dataView : {show: true, readOnly: false},
                //restore : {show: true},
                saveAsImage : {show: true, title:'Pict'}
            }
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: {
            type: 'value',
            boundaryGap: [0, 0.01]
        },
        yAxis: {
            type: 'category',
            data: ['巴西','印尼','美国','印度','中国','世界人口(万)']
        },
        series: [
            {
                name: 'responden',
                type: 'bar',
                label: {
                  normal: {
                    show: true,
                    position: 'right',
                    formatter: "{c}%"    
                  },                  
                },
                data: [18203, 23489, 29034, 104970, 131744, 630230]
            },           
        ]
      },
      fm2:{ nomors:[], areas:[], dapil:null },    
      charts : [],
      pertanyaans  : [], pertanyaanLoading  : false, 
      chartOption :  {
        title: {
            text: '',            
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            }
        },
        legend: {
            data: []
        },
        toolbox: {
            show : true,
            x: 'right',
            feature : {
                mark : {show: true},
                //dataView : {show: true, readOnly: false},
                //restore : {show: true},
                saveAsImage : {show: true, title:'Pict'}
            }
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: {
            type: 'value',
            boundaryGap: [0, 0.01]
        },
        yAxis: {
            type: 'category',
            data: ['巴西','印尼','美国','印度','中国','世界人口(万)']
        },
        series: [
            /*{
                name: 'responden',
                type: 'bar',
                label: {
                  normal: {
                    show: true,
                    position: 'right',
                    formatter: "{c}%"    
                  },                  
                },
                data: [18203, 23489, 29034, 104970, 131744, 630230]
            }, */ 
        ]
      },    
      sebarans:[], dapil:[], dapilLoading:false,
      area:{
        loading:false,
        items:[]
      }
    }  
  },
  computed:{
        
  },
  watch:{
    'fm.addr_idneg'(newId){if(newId){             
      model.node({id:newId,jilid_id:this.jilid.id,expand:'lembar,lembarDone,jumlahTps'}).then(res=>{this.negara.push(res)});
      this.provinsiLoading = true; //this.fm.addr_idkab = null;
      model.provinsi({parent:newId,jilid_id:this.jilid.id,expand:'lembar,lembarDone,jumlahTps'}).then(data=>{        
        this.provinsi=data; this.provinsiLoading = false;  
        this.fm.addr_idpro = this.fm.addr_idpro && data.find(x=>x.id === this.fm.addr_idpro) ? this.fm.addr_idpro : null;         
      })      
    }},
    'fm.addr_idpro'(newId){
      if(newId){      
        this.kabupatenLoading = true;
        model.kabupaten({parent:newId,jilid_id:this.jilid.id,expand:'lembar,lembarDone,jumlahTps'}).then(data=>{
          this.kabupaten=data; this.kabupatenLoading = false;
          this.fm.addr_idkab = this.fm.addr_idkab && data.find(x=>x.id===this.fm.addr_idkab) ? this.fm.addr_idkab:null;            
        })
        model.node({id:newId,jilid_id:this.jilid.id,expand:'lembar,lembarDone,jumlahTps'}).then(data=>{this.fm.addr_idneg = data.parent_id;})
      } else {
        this.fm.addr_idkab = null; this.kabupaten = []; 
      }      
      
      
      /*if(newId){      
      model.node({id:newId,jilid_id:this.jilid.id,expand:'lembar,lembarDone'}).then(res=>{this.provinsi.push(res)});
      this.kabupatenLoading = true; //this.fm.addr_idkab = null;
      model.kabupaten({parent:newId,jilid_id:this.jilid.id,expand:'lembar,lembarDone'}).then(data=>{
        this.kabupaten=data; this.kabupatenLoading = false;  
        this.fm.addr_idkab = this.fm.addr_idkab && data.find(x=>x.id === this.fm.addr_idkab) ? this.fm.addr_idkab : null;         
      })*/
    },
    'fm.addr_idkab'(newId){
      if(newId){      
        this.kecamatanLoading = true;
        model.kecamatan({parent:newId,jilid_id:this.jilid.id,expand:'lembar,lembarDone,jumlahTps'}).then(data=>{
          this.kecamatan=data; this.kecamatanLoading = false;
          this.fm.addr_idkec = this.fm.addr_idkec && data.find(x=>x.id===this.fm.addr_idkec) ? this.fm.addr_idkec:null;
          if(this.kecamatan.find(x=>x.id===this.fm.addr_idkec)){
            this.fm.addr_postcode = this.fm.addr_postcode ? this.fm.addr_postcode:this.kecamatan.find(x=>x.id===this.fm.addr_idkec).kodepos;
          }  
        })
        model.node({id:newId,jilid_id:this.jilid.id,expand:'lembar,lembarDone,jumlahTps'}).then(data=>{this.fm.addr_idpro = data.parent_id;})
      } else {
        this.fm.addr_idkec = null; this.kecamatan = []; 
      }      
    },
    'fm.addr_idkec'(newId){
      if(newId){      
        this.kelurahanLoading = true; 
        model.kelurahan({parent:newId,jilid_id:this.jilid.id,expand:'lembar,lembarDone,jumlahTps'}).then(data=>{
          this.kelurahan=data; this.kelurahanLoading = false;
          this.fm.addr_idkel = this.fm.addr_idkel && data.find(x=>x.id===this.fm.addr_idkel) ? this.fm.addr_idkel : null;           
        })      
        if(this.kecamatan.find(x=>x.id===newId)){
          let kodepos = this.kecamatan.find(x=>x.id===newId).kodepos;
          this.fm.addr_postcode = this.fm.addr_postcode ? this.fm.addr_postcode : kodepos; 
        }  
      } else {
        this.fm.addr_idkel = null; this.kelurahan = [];
      }      
    },   
    'fm.addr_idkel'(newId, oldId){      
      if(oldId===null && newId !== null){
        this.tpsLoading = true;
        model.node({id:newId,jilid_id:this.jilid.id, expand:'lembar,lembarDone,jumlahTps'}).then(data=>{
          this.kelurahan.push(data); 
          model.tps({idkel:data.id, jilid_id:this.jilid.id}).then(res=>{
            this.tps = res.data;
            this.tpsLoading = false;
          })
        })  
      } else if(this.kelurahan.find(x=>x.id===newId)){
        this.tpsLoading = true;
        model.tps({idkel:newId, jilid_id:this.jilid.id}).then(res=>{
          this.tps = res.data;
          this.tpsLoading = false;
        })
      }
    },
    'fm': {
      handler(){          
        if(this.load > 1){
          this.readItems()        
        }        
      }, 
      deep:true,
    },
    'fm2.nomors'(newIds) {
      if(Array.isArray(this.jilid.quetionnaires)){
        this.charts = [];
        newIds.forEach(id=>{        
          let q = this.jilid.quetionnaires.find(x=>x.no==id);
          if(q){
            this.charts.push({no:q.no, type:q.type, question:q.question, loading:true, color:'black', option:q.option, chartOption:{}, data:[], columns:[],  height:390});        
          }          
        })
      }
      this.readItems2()        
    },
    'fm2.areas':debounce(function() {
      this.refreshItems2()        
    }, 2000),
    'fm2.dapil'(newId) {    
      let dapil = this.dapil.find(x=>x.id==newId)  
      if(dapil){
        if(this.disabled.addr_idkab){
          this.fm2.areas = dapil.node_ids          
        } else if(this.disabled.addr_idpro){
          this.fm2.areas = dapil.node_ids
        }
      } else {
        this.fm2.areas = []
      }
    },  
    /*'fm2': {
      handler(){        
        this.readItems2()
      }, 
      deep:true,
    },*/   
  },  
  mounted() {
    this.loading = true;
    this.init();    
  },
  methods: {
    search: debounce(function (term) {
      this.term = term;
      this.readItems()
    }, 800),

    init(){
      if(this.jilid.node_id){        
        model.node({id:this.jilid.node_id,jilid_id:this.jilid.id,expand:'lembar,lembarDone,jumlahTps'}).then(res=>{
          if(res.level !== null){
            this.disabled.addr_idpro = false;
            this.disabled.addr_idkab = false;
            this.disabled.addr_idkec = false;
            this.disabled.addr_idkel = false;
            this.fm.addr_idneg = null;
            this.fm.addr_idpro = null;
            this.fm.addr_idkab = null;
            this.fm.addr_idkec = null;
            this.fm.addr_idkel = null;
            switch(parseInt(res.level)){
              case 0: this.fm.addr_idneg = res.id;
                break;
              case 1: this.fm.addr_idpro = res.id; 
                this.disabled.addr_idpro = true;
                break;
              case 2: this.fm.addr_idkab = res.id; 
                this.disabled.addr_idpro = true;
                this.disabled.addr_idkab = true;
                break;
              case 3: this.fm.addr_idkec = res.id; 
                this.disabled.addr_idpro = true;
                this.disabled.addr_idkab = true;
                this.disabled.addr_idkec = true;
                break;
              case 4: this.fm.addr_idkel = res.id; 
                this.disabled.addr_idpro = true;
                this.disabled.addr_idkab = true;
                this.disabled.addr_idkec = true;
                this.disabled.addr_idkel = true;
                break;
            }
          }   
          this.readItems2();  
          this.readItems();          
          setTimeout(()=>{this.load ++;}, 12000)           
        })
        this.dapilLoading = true
        model.dapil({node_id:this.jilid.node_id}).then(res=>{
          this.dapilLoading = false
          this.dapil = res
        })  
      }
      if(Array.isArray(this.jilid.quetionnaires)){
        let no = 0;
        this.jilid.quetionnaires.forEach(q=>{
          this.pertanyaans.push({id:q.no, name:q.no+'. '+q.question, loading:true,option:{}});
          if( no < 1){
            this.fm2.nomors.push(q.no);
            no++;
          }                              
        })
      }
    },

    readItems : debounce(function (e) {      
      this.loading = true
      
      const params = {        
        jilid_id: this.jilid.id,
        idpro:this.fm.addr_idpro,
        idkab:this.fm.addr_idkab,
        idkec:this.fm.addr_idkec,
        idkel:this.fm.addr_idkel,
        expand:'quetionnaires'
      }      

      model.sebaran(params).then(data => {
        if(Array.isArray(data)){
          this.height1 = data.length*40 > 417 ? data.length*40 : 417;
          this.option1.yAxis.data = [];
          this.option1.series[0].data = [];
          this.color = this.$color();
          this.option1.series[0].itemStyle = {color:this.color};
          let total = 0;
          data.forEach(item=>{
            this.option1.yAxis.data.push(item.area_name+"\n["+item.people+"]");
            total += parseInt(item.people);
          });
          this.area.items = []
          data.forEach(item=>{
            this.option1.series[0].data.push(parseFloat(parseInt(item.people)/total*100).toFixed(2));            
            this.area.items.push({id:item.area_id, name:item.area_name})
          });
        }
        this.loading = false;              
        this.load ++;        
        /*if(this.firstime){
          this.firstime = false;
        } else {
          this.readItems2();
        }*/        
      })
    }, 500),  
    
    readItems2: debounce(function (e) {      
      if(Array.isArray(this.charts)){
        this.charts.forEach(c=>{
          c.loading = true;              
          const params = {        
            jilid_id: this.jilid.id,        
            no: c.no,
            idpro:this.fm.addr_idpro,
            idkab:this.fm.addr_idkab,
            idkec:this.fm.addr_idkec,
            idkel:this.fm.addr_idkel,        
            expand:'quetionnaires'
          }

          model.silangSebaran(params).then(data => {
            this.sebarans = data; 
            c.columns = [];                  
            if(Array.isArray(data) && Array.isArray(c.option)){
              let columns = [];
              if(c.type == 3){
                data.forEach(item=>{
                  if(Array.isArray(item.child)){
                    item.child.forEach(child => {
                      if(!columns.includes(child.answer)){
                        columns.push(child.answer)                      
                      }
                    })
                  }
                });
              } else {
                c.option.forEach(opt=>{
                  columns.push(opt.id)
                })
              }                            

              c.chartOption = JSON.parse(JSON.stringify(this.chartOption));  
              c.chartOption.legend.data = [];  
              c.chartOption.yAxis.data = [];            
              c.chartOption.series     = [];
              columns.forEach(column=>{
                let opt = c.option.find(x=>x.id==column);
                if(c.type==3){
                  c.columns.push({id:column, text:opt?opt.key:column});
                  c.chartOption.legend.data.push(opt?opt.key:column);                                    
                  c.chartOption.series.push({name: opt?opt.key:column,type: 'bar',label: {normal: {show: true,position: 'right',formatter: "{c}%"}},data: []});                                     
                } else {                  
                  c.columns.push({id:column, text:opt?opt.value:column});                  
                  c.chartOption.legend.data.push(opt?opt.value:column);                                    
                  c.chartOption.series.push({name: opt?opt.value:column,type: 'bar',label: {normal: {show: true,position: 'right',formatter: "{c}%"}},data: []});                                     
                }                                          
              })

              c.total_people = [];
              c.total_persen = []; 
              c.subtotal = 0;                                           
              columns.forEach((column,i)=>{
                c.total_people[i] = 0;
              });  
              c.data  = []                            
              data.forEach(item=>{ 
                if(this.fm2.areas.includes(item.area_id) || this.fm2.areas.length == 0){
                  c.subtotal += item.people                  
                  c.data.push(item)                  
                  item.childs = []; 
                  c.chartOption.yAxis.data.push(item.area_name);                 
                  if(Array.isArray(item.child)){                                                    
                    columns.forEach((column,i)=>{
                      let dat = item.child.find(x=>x.answer==column);
                      if(dat){
                        let persen = parseFloat(parseInt(dat.people)/parseInt(item.people)*100).toFixed(2);
                        item.childs.push({people: dat.people, answer : dat.answer, persen:persen});
                        c.chartOption.series[i].data.push(persen);
                        c.total_people[i] += parseInt(dat.people);                                                                                        
                      } else {
                        item.childs.push({people: 0, answer : null, persen:0});
                        c.chartOption.series[i].data.push(0);
                        c.total_people[i] += parseInt(0);                                          
                      }
                    });                                    
                  }
                }                                    
              });  
              c.height = (c.data.length*columns.length*20) > 390 ? (c.data.length*columns.length*20) : 390;     
              
              let tohapus = []
              columns.forEach((column,i)=>{
                c.total_persen[i] = parseFloat(parseInt(c.total_people[i])/parseInt(c.subtotal)*100).toFixed(2);
                if(parseFloat(c.total_persen[i])<= 0){
                  tohapus.push(i)
                }
              });        

              c.columns = c.columns.filter(function(value, index) {
                  return tohapus.indexOf(index) == -1;
              })  
              for(var j in c.data){
                c.data[j].childs = c.data[j].childs.filter(function(value, index) {
                  return tohapus.indexOf(index) == -1;
                })                  
              }                  
              c.total_persen = c.total_persen.filter(function(value, index) {
                return tohapus.indexOf(index) == -1;
              })   
                                        
              c.color = this.$color() || '#000'; 
            }
            c.loading = false
          })
        })
      }            
    }, 500),

    refreshItems2(){
      if(Array.isArray(this.charts)){
        this.charts.forEach(c=>{
          c.loading = true;          
          let data = JSON.parse(JSON.stringify(this.sebarans));
          c.data = [];
          c.columns = [];                  
          if(Array.isArray(data) && Array.isArray(c.option)){
            let columns = [];
            if(c.type == 3){
              data.forEach(item=>{
                if(Array.isArray(item.child)){
                  item.child.forEach(child => {
                    if(!columns.includes(child.answer)){
                      columns.push(child.answer)                      
                    }
                  })
                }
              });
            } else {
              c.option.forEach(opt=>{
                columns.push(opt.id)
              })
            }

            c.chartOption = JSON.parse(JSON.stringify(this.chartOption));  
            c.chartOption.legend.data = [];  
            c.chartOption.yAxis.data = [];            
            c.chartOption.series     = [];
            columns.forEach(column=>{
              let opt = c.option.find(x=>x.id==column);
              if(c.type==3){
                c.columns.push({id:column, text:opt?opt.key:column});
                c.chartOption.legend.data.push(opt?opt.key:column);                                    
                c.chartOption.series.push({name: opt?opt.key:column,type: 'bar',label: {normal: {show: true,position: 'right',formatter: "{c}%"}},data: []});                                     
              } else {                  
                c.columns.push({id:column, text:opt?opt.value:column});                  
                c.chartOption.legend.data.push(opt?opt.value:column);                                    
                c.chartOption.series.push({name: opt?opt.value:column,type: 'bar',label: {normal: {show: true,position: 'right',formatter: "{c}%"}},data: []});                                     
              }                                          
            })

            c.total_people = [];
            c.total_persen = [];      
            c.subtotal = 0;
            columns.forEach((column,i)=>{
              c.total_people[i] = 0;
            });  
            c.data  = []                            
            data.forEach(item=>{  
              if(this.fm2.areas.includes(item.area_id) || this.fm2.areas.length == 0){
                c.subtotal += item.people;              
                c.data.push(item)                  
                item.childs = []; 
                c.chartOption.yAxis.data.push(item.area_name);                 
                if(Array.isArray(item.child)){                                                    
                  columns.forEach((column,i)=>{
                    let dat = item.child.find(x=>x.answer==column);
                    if(dat){
                      let persen = parseFloat(parseInt(dat.people)/parseInt(item.people)*100).toFixed(2);
                      item.childs.push({people: dat.people, answer : dat.answer, persen:persen});
                      c.chartOption.series[i].data.push(persen);
                      c.total_people[i] += parseInt(dat.people);                                          
                    } else {
                      item.childs.push({people: 0, answer : null, persen:0});
                      c.chartOption.series[i].data.push(0);
                      c.total_people[i] += parseInt(0);                                          
                    }
                  });                                    
                }
              }                                    
            });  
            c.height = (c.data.length*columns.length*20) > 390 ? (c.data.length*columns.length*20) : 390;            
            let tohapus = []
            columns.forEach((column,i)=>{
              c.total_persen[i] = parseFloat(parseInt(c.total_people[i])/parseInt(c.subtotal)*100).toFixed(2);
              if(parseFloat(c.total_persen[i])<= 0){
                tohapus.push(i)
              }
            });          

            c.columns = c.columns.filter(function(value, index) {
                return tohapus.indexOf(index) == -1;
            })  
            for(var j in c.data){
              c.data[j].childs = c.data[j].childs.filter(function(value, index) {
                return tohapus.indexOf(index) == -1;
              })                  
            }                  
            c.total_persen = c.total_persen.filter(function(value, index) {
              return tohapus.indexOf(index) == -1;
            }) 
       
            c.color = this.$color() || '#000'; 
          }
          setTimeout(()=>{c.loading = false;},500)  
        })              
      }
    },

    export2excel(i){
      var filename = 'Report.'+i+'.';
      filename    += this.$moment().format('DDMMYY.HHmm');
      new Table2Excel('#export'+i+' table',{
        plugins: [{
          workcellCreated ({ workbook, tables, worksheet, table, workcell, cell, cellStyle, rowRange, colRange }) {
            workcell.style = {
              ...workcell.style,
              font: {},
              color: '#000'
            }
          }
        }]
      }).export(filename);
    },

    getNodesActive(){
      if(this.fm.addr_idkel){
        return this.tps;
      } else if(this.fm.addr_idkec){
        return this.kelurahan;
      } else if(this.fm.addr_idkab){
        return this.kecamatan;
      } else if(this.fm.addr_idpro){
        return this.kabupaten;
      } else {
        return [];
      }
    },

    totalDpt(items){
      let dpt = 0, lembar = 0, lembarDone = 0, jumlahTps =0;
      items.forEach(item=>{
        dpt += parseInt(item.dpt)
        lembar += parseInt(item.lembar)
        lembarDone += parseInt(item.lembarDone)
        jumlahTps += parseInt(item.jumlahTps)
      })
      return {dpt:dpt, lembar:lembar, lembarDone: lembarDone, jumlahTps:jumlahTps};
    },
  },  
}
</script>
<style>
.tb-normal{    
  border-collapse: collapse;
}
.tb-normal td, .tb-normal th {
  border: 1px solid #ddd;
  padding: 4px 6px;
}
</style>